import React, { Component, createRef } from "react";
import { I18n } from "react-redux-i18n";
import cx from "classnames";
import {
  ComponentItem,
  ComponentTitle,
  IconWrapper,
  BetaLabel,
  PremiumLabel,
  NewLabel,
  DisabledContainer,
} from "./styles";
import { PremiumCrow } from "../MainHeader/icons";

class Tool extends Component {
  constructor(props) {
    super(props);
    this.dragRef = createRef();
    this.state = {
      position: null,
    };
  }

  componentDidMount() {
    const element = this.dragRef.current;
    element.addEventListener("dragstart", this.handleDragStart, false);
    element.addEventListener("dragend", this.handleDragEnd, false);
  }

  componentWillUnmount() {
    const element = this.dragRef.current;
    element.removeEventListener("dragstart", this.handleDragStart);
    element.removeEventListener("dragend", this.handleDragEnd);
  }

  handleDragEnd = (e) => {
    console.log("Drag Ended", e);
    window.DragManager.clear(true);
  };

  handleDragStart = (e) => {
    const objectBeingDragged = this.dragObject();
    const objInJson = JSON.stringify(objectBeingDragged); // pass to JSON stringify before setData because it's a dumb method.
    e.dataTransfer.setData("element", objInJson);
    window.DragManager.registerStart("ADD_ELEMENT", objectBeingDragged);
  };

  dragObject = () => {
    const { component, version, props, editMode } = this.props;
    return {
      dragType: "Element",
      component,
      version,
      props,
      editMode,
    };
  };

  storePosition = () => {
    const element = this.dragRef.current;
    this.setState({ position: element.getBoundingClientRect() });
  };

  render() {
    const {
      icon,
      title,
      component,
      beta,
      newElement,
      disabled,
      cerberus,
      hasPermissionFunc,
      disabledText,
    } = this.props;

    const { position } = this.state;

    const hasPermission =
      !cerberus ||
      (cerberus && hasPermissionFunc && hasPermissionFunc(cerberus));

    const componentClasses = cx(`element-${component.toLowerCase()}`, {
      disabled,
      cerberus: !hasPermission,
    });

    return (
      <ComponentItem
        beta={beta}
        newElement={newElement}
        onMouseEnter={this.storePosition}
        className={componentClasses}
        ref={this.dragRef}
        draggable={!disabled && hasPermission}
      >
        {!!cerberus && (
          <PremiumLabel isPremium={hasPermission}>
            <PremiumCrow /> <span>PREMIUM</span>
          </PremiumLabel>
        )}
        {beta && <BetaLabel>BETA</BetaLabel>}
        {newElement && <NewLabel>{I18n.t("editPanel.newElement")}</NewLabel>}
        <IconWrapper src={icon} alt={title} />
        <ComponentTitle>{title}</ComponentTitle>
        {disabled && (
          <DisabledContainer
            position={position}
            dangerouslySetInnerHTML={{ __html: disabledText }}
          />
        )}
      </ComponentItem>
    );
  }
}

export default Tool;
